export * from './Typography';
export { default } from './Typography';
//# sourceMappingURL=index.js.map